<template>
  <div id="app">
    <transition :name="transitionName">
      <router-view class="ui-view" transition-mode="out-in"/>
    </transition>
  </div>
</template>
<script>

export default {
  name: 'App',
  data() {
    return {
      transitionName: '',
      isPc: false
    }
  },

  watch: {//使用watch 监听$router的变化
    $route(to, from) {
      if (to.meta.index > from.meta.index) {
        this.transitionName = 'slide-right';
      } else {
        this.transitionName = 'slide-left';
      }
    }
  },
  mounted() {
    this.isPc = !this._isMobile();
    if (this._isMobile()) {
      document.body.className = 'pc_index_page'
    }
  },
  methods: {
    _isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    }
  }
}
</script>
<style lang="scss">
html, body, #app {
  background-color: rgba(255, 255, 255, 1);
  width: 100%;
  height: 100%;
}

.pc_index_page {
  position: absolute;
  width: 400px;
  left: calc(100vw - 50vw - 200px);
}

body {
  padding: constant(safe-area-inset-top) constant(safe-area-inset-right) constant(safe-area-inset-bottom) constant(safe-area-inset-left);
}

@supports (bottom: env(safe-area-inset-bottom)) {
  body {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}

body {
  display: block;
  margin: 0;
  padding: 0;
}

.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 600ms;
  -moz-transition: all 600ms; /* Firefox 4 */
  -webkit-transition: all 600ms; /* Safari and Chrome */
  -o-transition: all 600ms; /* Opera */
  position: absolute;
}

.slide-right-enter {
  transform: translate3d(100%, 0, 0);
  -webkit-transform: translate3d(100%, 0, 0);
  -ms-transform: translate3d(100%, 0, 0);
  -moz-transform: translate3d(100%, 0, 0);
  -o-transform: translate3d(100%, 0, 0);
}

.slide-right-leave-active {
  transform: translate3d(-100%, 0, 0);
  -webkit-transform: translate3d(-100%, 0, 0);
  -ms-transform: translate3d(-100%, 0, 0);
  -moz-transform: translate3d(-100%, 0, 0);
  -o-transform: translate3d(-100%, 0, 0);
}

.slide-left-enter {
  transform: translate3d(-100%, 0, 0);
  -webkit-transform: translate3d(-100%, 0, 0);
  -ms-transform: translate3d(-100%, 0, 0);
  -moz-transform: translate3d(-100%, 0, 0);
  -o-transform: translate3d(-100%, 0, 0);
}

.slide-left-leave-active {
  transform: translate3d(100%, 0, 0);
  -webkit-transform: translate3d(100%, 0, 0);
  -ms-transform: translate3d(100%, 0, 0);
  -moz-transform: translate3d(100%, 0, 0);
  -o-transform: translate3d(100%, 0, 0);
}
</style>
